import { t as translateDate } from './translate-date.js';
import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Res Online v2**
 *
 * @exports bs_414
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    let refreshPrice;
    /**
       *
       * @memberOf module:bs_414
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot(ctx) {
        const container = document.body;
        if (container) {
            const undelegate = thn.delegate('click', '.wbe-guestSelection-container-buttons > button:not(.wbe-inverted), .wbe-removeRoom', () => {
                setTimeout(() => thn.widgets.price.refresh(), 300);
            });
            thn.shutdown(() => {
                undelegate();
            });
        }
    };
    /**
       * @memberOf module:bs_414
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(thn.pageCheck, 500);
    };
    /**
       * @memberOf module:bs_414
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('.wbe-roomConfig');
        if (container && !refreshPrice) {
            refreshPrice = thn.debounce(() => ctx.widget.refresh(), 400);
            thn.observeDom(container, refreshPrice, {
                childList: true,
                subtree: false,
                attributes: true,
            });
            thn.pageUnload(() => {
                refreshPrice.cancel();
                thn.stopObserveDom(container, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
       * @memberOf module:bs_414
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        const dateBeginText = document.querySelector('#room_a-arrival-calendar-text')?.textContent;
        const dateEndText = document.querySelector('#room_d-depart-calendar-text')?.textContent;
        const dateBegin = translateDate((dateBeginText || ''), thn.data.language);
        const dateEnd = translateDate(dateEndText || '', thn.data.language);
        let nights;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        // Prices & Currency || No Rooms
        widgetData.roomsDispo = [];
        const numberOfRooms = document.querySelectorAll('.wbe-roomsContainer .wbe-roomConfig')?.length;
        const adultsList = document.querySelectorAll('#wbe_numAdults');
        const childrenList = document.querySelectorAll('#wbe_numChilds');
        const childrenAgeList = document.querySelectorAll('step-childrenage select');
        const prices = [];
        for (let i = 0; i < numberOfRooms; i += 1) {
            const roomInfo = {
                adults: thn.parseNumber(adultsList[i]?.value) || 1,
                children: thn.parseNumber(childrenList[i]?.value) || 0,
                childrenAges: [],
            };
            for (let j = 0; j < roomInfo.children; j += 1) {
                roomInfo.childrenAges.push(thn.parseNumber(childrenAgeList[j]?.value));
            }
            widgetData.roomsDispo.push(roomInfo);
            const priceSelector = `#wbe_roomConfig_${i} .wbe-room-list-rate-price span:not(.wbe-room-list-rate-price-infoSmall)`;
            const pricesArray = [...document.querySelectorAll(priceSelector)].map((priceEl) => thn.parseNumber(priceEl.textContent)).filter(Boolean);
            const price = thn.notEmpty(pricesArray) && Math.min(...pricesArray) / nights;
            if (price) {
                prices.push(price);
            }
        }
        const currencySelector = '.wbe-room-list-rate-price span:not(.wbe-room-list-rate-price-infoSmall)';
        const currency = thn.parseCurrency(document.querySelector(currencySelector)?.textContent);
        if (thn.notEmpty(prices) && currency && nights) {
            widgetData.price = prices.reduce((total, current) => total + current, 0);
            widgetData.currency = currency;
            widgetData.roomDetails = engine._roomDetailsParseData(widgetData.adults, widgetData.children);
            widgetData.set = true;
        }
        return widgetData;
    };
    /**
      *
      * @memberOf module:bs_414
      *
      */
    engine._roomDetailsParseData = function roomDetailsParseData(adults, children) {
        const roomElArray = [...document.querySelectorAll('.wbe-room-list-room-InfoBlock')];
        if (thn.empty(roomElArray)) {
            return {};
        }
        const roomsInfo = roomElArray.map((room) => {
            const roomName = room.querySelector('.wbe-infoBox-summary-room-name')?.textContent;
            const roomType = getRoomType(roomName);
            const roomRates = [...room.querySelectorAll('.wbe-room-list-room-rate')].map((rate) => {
                const rateName = rate.querySelector('.wbe-room-list-rate-name')?.textContent;
                const price = thn.parseNumber(rate.querySelector('.wbe-room-list-rate-price span:not(.wbe-room-list-rate-price-infoSmall)')?.textContent);
                const hasBreakfast = !!rateName?.match(/incl. Breakfast|inkl. Frühstück/);
                const isRefundable = !rate.querySelector('.wbe-room-list-rate-options ul')?.textContent?.match(/Not cancelable|Nicht stornierbar/);
                return {
                    id: '',
                    name: rateName,
                    totalNight: price,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
            });
            return {
                id: '',
                name: roomName,
                adults: adults || 2,
                children: children || 0,
                type: roomType,
                prices: roomRates,
            };
        });
        return roomsInfo;
    };
    /**
       * @memberOf module:bs_414
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const dataLayer = window.dataLayer;
        // Booking id
        const bookingId = thn.objectGet(dataLayer, 'transaction_id', { first: false }) || thn.objectGet(dataLayer, 'id', { first: false });
        if (!bookingId) {
            widgetData.set = false;
            thn.logger.debug('************** Booking ID does not exist *****************');
            return widgetData;
        }
        // Price & Currency
        const price = thn.objectGet(dataLayer, 'value', { first: false }) || thn.objectGet(dataLayer, 'revenue', { first: false });
        const currency = thn.objectGet(dataLayer, 'currency', { first: false });
        widgetData.price = thn.parseNumber(price);
        widgetData.currency = thn.parseCurrency(currency);
        // Dates
        const dateBegin = thn.objectGet(dataLayer, 'wbeArrival', { first: false })?.replace(/-/g, '/');
        const dateEnd = thn.objectGet(dataLayer, 'wbeDeparture', { first: false })?.replace(/-/g, '/');
        widgetData.bookingId = bookingId;
        widgetData.dateBegin = dateBegin;
        widgetData.dateEnd = dateEnd;
        return widgetData;
    };
    return engine;
}

export { factory };
